import Image from "next/image";
import { examplesItems } from "../constants";
import styles from "./examplesMenu.module.scss";
import { useEffect } from "react";
import * as ga from "../../../lib/ga";

const ExamplesMenu = ({ type, activeList, setActiveList, t }) => {
	useEffect(() => {
		setActiveList(examplesItems[type][0]);
	}, [type]);

	const onClick = (item) => {
		console.log(item);
		setActiveList(item);
		ga.event({ action: `Examples ${type}: click to menu btn'`, params: { event_category: `Examples ${type}` } });
	};

	return (
		<div className={`${styles.menu} ${styles[type]}`}>
			<h3 className={styles.title}>{type !== "text" ? t["select_image"] || "Select image" : t["prompt"] || "Prompt"}</h3>
			<div className={`${styles.itemsWrapper} ${styles.menuItemsWrapper}`}>
				{type !== "text" &&
					examplesItems?.[type]?.map((item) => (
						<button key={item.originalUrl} className={`${styles.btn}  ${activeList?.originalUrl === item.originalUrl ? styles.active : ""}`} onClick={() => onClick(item)}>
							<Image className={styles.img} width={100} height={100} src={item.originalUrl} alt={"Original"} />
						</button>
					))}
				{type === "text" &&
					examplesItems?.[type]?.map((item) => (
						<button className={`${styles.textBtn} ${activeList?.prompt === item.prompt ? styles.active : ""}`} key={item.prompt} onClick={() => onClick(item)}>
							{t[item.prompt] || item.promptText}
						</button>
					))}
			</div>
		</div>
	);
};

export default ExamplesMenu;
